import { useQuery } from "@tanstack/react-query";

import type { SessionUser } from "@/app/session/SessionProvider";
import { api, unwrap } from "@/shared/api/client";

/** The signed-in person (GET /auth/me): their profile and the permissions the server grants. */
export const meKey = ["me"] as const;

/* Permissions change rarely; a minute keeps them fresh without asking on every screen. */
const ME_STALE_MS = 60_000;

export function fetchMe(): Promise<SessionUser> {
  return unwrap(api.GET("/api/v1/auth/me"));
}

/**
 * The signed-in person, kept fresh: seeded from the session when someone signs in, then
 * refetched after a minute and whenever the window regains focus, so a role change made by
 * someone else shows up without signing in again.
 */
export function useMe(enabled = true) {
  return useQuery({
    queryKey: meKey,
    queryFn: fetchMe,
    staleTime: ME_STALE_MS,
    refetchOnWindowFocus: true,
    enabled,
  });
}
